module.exports = __webpack_public_path__ + "img/clipboard.eea08f11.svg";